/* eslint-disable default-case */
/* eslint-disable indent */
import { combineReducers } from "redux";
import keplerGlReducer from "kepler.gl/reducers";
import appReducer from "./appReducer";
import dataReducer from "./dataReducer";
import reportsReducer from "./reports";

const customizedKeplerGlReducer = keplerGlReducer.initialState({
  mapState: {
    // initial zoom level (from 0 to 24)
    zoom: 10,
  },
  uiState: {
    // hide side panel to disallow user customize the map
    readOnly: true,

    // customize which map control button to show
    mapControls: {
      visibleLayers: {
        show: false,
      },
      mapDraw: {
        show: false,
      },
      mapLegend: {
        show: false,
      },
      toggle3d: {
        show: false,
      },
      splitMap: {
        show: false,
      },
    },
  },
});

const reducers = combineReducers({
  keplerGl: customizedKeplerGlReducer,
  app: appReducer,
  data: dataReducer,
  reports: reportsReducer,
});

/*const composedReducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE_PERSPECTIVE":
      return {
        ...state,
        keplerGl: {
          ...state.keplerGl,
          kglMap: {
            ...state.keplerGl.kglMap,
            mapState: mapStateUpdaters.togglePerspectiveUpdater(
              state.keplerGl.kglMap.mapState
            )
          }
        }
      };
  }
  return reducers(state, action);
};*/

export default reducers;
